import Request from './request';
import API_METHODS from './enum';
import { homepage } from '../../package.json';

const defaults = {
  apiUrl: 'api',
  portalUrl: '',
  user: '',
  folder: ''
};

export default class Api {
  constructor(params) {
    this.props = Object.assign({}, defaults, params);
    this.request = new Request(this.props.token);
    this.basename = process.env.NODE_ENV !== 'production' ? '' : homepage;
  }

  setApiUrl(url) {
    this.props.apiUrl = url;
  }

  setPortalUrl(url) {
    this.props.portalUrl = url;
  }

  setAuth(user) {
    this.props.user = user;
  }

  getToken() {
    return window.authManager.getToken();
  }

  getUsername() {
    return this.props.user.username;
  }

  getPortalUrl() {
    return this.props.portalUrl;
  }

  // getAppConfig() {
  //   return new Promise((resolve, reject) => {
  //     this.request
  //       .makeRequest({
  //         url: `${this.basename}/config.json`,
  //         method: 'get'
  //       })
  //       .then(resp => resolve(resp));
  //   });
  // }

  getUserGroups() {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/community/users/${this.getUsername()}`,
          method: 'post',
          data: { f: 'json', token: this.getToken() }
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }

  getAllPortalUsers() {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/${API_METHODS.GET_USERS}`,
          method: 'post',
          data: {
            f: 'json',
            num: 100,
            excludeSystemUsers: true,
            token: this.getToken()
          }
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }

  searchPortal(q) {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/${API_METHODS.SEARCH}`,
          method: 'get',
          data: { f: 'json', q, token: this.getToken() }
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }

  getPortalItem(id) {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/${
            API_METHODS.GET_ITEM
          }`.replace('{itemId}', id),
          method: 'get',
          data: { f: 'json', token: this.getToken() }
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }

  getPortalItemData(id) {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/${
            API_METHODS.GET_ITEM_DATA
          }`.replace('{itemId}', id),
          method: 'get',
          data: { f: 'json', token: this.getToken() }
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }

  addPortalItem(data) {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/${
            API_METHODS.ADD_ITEM
          }`.replace('{username}', this.getUsername()),
          method: 'post',
          data: { f: 'json', ...data, token: this.getToken() }
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }

  updatePortalItem(id, data) {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/${API_METHODS.UPDATE_ITEM}`
            .replace('{itemId}', id)
            .replace('{username}', this.getUsername()),
          method: 'post',
          data: { f: 'json', text: data, token: this.getToken() }
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.request
        .makeRequest({
          url: `${this.getPortalUrl()}/sharing/rest/oauth2/signout`,
          handleAs: 'text'
        })
        .then(resp => resolve(resp), error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/api.js